import { BANK_NO } from '@/constant'
import { BANK_MAP } from '@/model/card'
import { defineStore } from 'pinia'
import { useAppStore } from './app'

export const useBankStore = defineStore({
  id: 'bank',
  state: (): BankState => ({
    available: 0, // 是否可用
    backUrl: '', // 银行渠道背景图片地址
    bankNo: BANK_NO.BOC_VM, // 银行code
    bankName: '', // 银行名称

    discountActId: '', // 折扣活动id
    discountAmount: 0, // 折扣类型
    discountType: '', // 折扣类型
    priceTips: '', // 价格tips
    tips: '', // tips
  }),
  getters: {},
  actions: {
    updateBankNo() {
      const banks = [...BANK_MAP.values()]

      this.bankNo =
        banks.find((bank) => bank.payTypes.includes(useAppStore().payType))?.id || BANK_NO.BOC_VM
    },
  },
  persist: {
    enabled: true,
    // strategies: [
    //   {
    //     key: 'my_user',
    //     storage: localStorage,
    //   },
    // ],
  },
})
